/*
 * @Author: 朱占伟
 * @LastEditors: 朱占伟
 * @description: 应用容器
 * @Date: 2021-09-09 13:15:41
 * @LastEditTime: 2021-12-31 11:06:24
 */


import 'views/index';
// import { test } from 'model/test';
import Header from "components/Header"
// import Footer from "components/Footer"
import { withRouter } from 'react-router-dom'
import styles from './index.less'
// import DynamicBackground from 'components/DynamicBackground'
import zhCN from 'antd/es/locale/zh_CN';
import { ConfigProvider } from 'antd'
import { connect } from 'react-redux'

class App extends React.Component {
  constructor() {
    super();
  }
  containerRef = React.createRef()
  //浏览器适配
  adaptation = () => {

    var baseWidth = 1920
    var baseHeight = 937
    var docEl = document.documentElement,
      resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
      doc = document,
      recalc = () => {
        if (this.props.location.pathname == '/') {
          //清空样式
          {
            doc.body.style.minWidth = 'auto'
            doc.body.style.maxWidth = 'none'
            docEl.style.fontSize = '16px'
          }
          var width_proportion = window.innerWidth / baseWidth
          var height_proportion = window.innerHeight / baseHeight

          doc.body.style.position = 'absolute'
          doc.body.style.left = '50%'
          doc.body.style.top = '50%'
          doc.body.style.width = baseWidth + 'px'
          doc.body.style.height = baseHeight + 'px'
          doc.body.style.transformOrigin = 'left top'
          doc.body.style.overflow = 'hidden'
          if (width_proportion < height_proportion) {
            doc.body.style.transform = `scale(${width_proportion}) translate(-50%, -50%)`
          } else {
            doc.body.style.transform = `scale(${height_proportion}) translate(-50%, -50%)`
          }

        } else {
          //清空样式
          {
            doc.body.style.position = 'relative';
            doc.body.style.left = 'auto';
            doc.body.style.top = 'auto';
            doc.body.style.width = 'auto';
            doc.body.style.height = 'auto';
            // doc.body.style.transform = 'scale(1)';
            doc.body.style.transform = 'none';
            doc.body.style.overflow = 'auto'
            document.querySelector('html').style.backgroundColor = 'white'
          }
          doc.body.style.minWidth = '1300px'
          doc.body.style.maxWidth = '1920px'
          var clientWidth = docEl.clientWidth;
          var clientHeight = docEl.clientHeight
          if (!clientWidth) return;
          if (clientWidth <= 1200) {
            clientWidth = 1200
          } else if (clientWidth >= 1920) {
            clientWidth = 1920
          }
          // docEl.style.fontSize = 16 * (clientWidth / baseWidth) + 'px';
        }
      };

    window.onresize = recalc
    recalc()
  }

  //生命周期调接口
  async componentDidMount() {
    this.adaptation()
    this.props.dispatch({
      type: 'CONTAINER',
      payload: this.containerRef
    })
  }
  componentDidUpdate(oldProps, oldState) {
    if (oldProps.location.pathname !== this.props.location.pathname) {
      document.querySelector('html').scrollTo && document.querySelector('html')?.scrollTo(0, 0)
      this.adaptation()
    }
  }

  render() {
    return (
      <ConfigProvider locale={zhCN}>
        {this.props.location.pathname == '/'
          ? this.props.children
          : <div className={styles.container}>
            {/* 顶部导航 */}
            <Header />
            {/* 详细内容 */}
            {/* <Router /> */}
            <div className={styles.router} ref={this.containerRef}>
              {this.props.children}
            </div>
          </div>
        }
      </ConfigProvider>
    )
  }

}

export default connect()(withRouter(App))